import { render, staticRenderFns } from "./LiChengSyncButton.vue?vue&type=template&id=d35d6a72"
import script from "./LiChengSyncButton.vue?vue&type=script&lang=js"
export * from "./LiChengSyncButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports